export default [
  {
    path: "/futures",
    name: "taskCenter",
    redirect: "/futures/taskCenter",
    component: () => import("@/layout/index"),
    children: [
      {
        path: "taskCenter",
        name: "taskCenter", // index
        component: () => import("@/pages/v2/taskCenter"),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/v2/taskCenter/index.js